export function generateFilter(ticketIds) {
    return {
        where: { id: { inq: ticketIds } },
    };
}

export default generateFilter;
